import {
  AttendanceClassIllustration,
  CurriculumIllustration,
  MobilePhoneIcon,
  SchoolEventIllustration,
  UpdateIcon,
} from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { showLicenseHint } from '../../../components/LicenseHint/LicenseHint';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SubstitutionsSetupPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canWriteSubstitution()}
      title={`${t('substitutions.title', { count: 2 })} ${t('substitutions.setup').toLowerCase()}`}
    >
      <IconMenu headline={t('common.whatToSetup')} hasMarginBottom columns={3}>
        <IconMenuItem
          label={t('functionClass.title', { count: 2 })}
          icon={<AttendanceClassIllustration />}
          bubbleType={7}
          onClick={() => navigate(t('routes.functionClass.slug'))}
        />
      </IconMenu>
      <IconMenu headline={t('settings.title', { count: 2 })} columns={3}>
        <IconMenuItem
          label={t('synchronizations.synchronization')}
          icon={<UpdateIcon />}
          bubbleType={8}
          onClick={() => navigate(t('routes.synchronization.slug'))}
        />
        <IconMenuItem
          label={t('substitutions.substitutionPlan')}
          icon={<CurriculumIllustration style={{ strokeWidth: '1.5' }} />}
          bubbleType={5}
          onClick={() => navigate(t('routes.substitutionPlanSettings.slug'))}
        />
        <IconMenuItem
          label={t('substitutions.app.title')}
          icon={<MobilePhoneIcon />}
          bubbleType={9}
          // Ohne gebuchte VPlan-App der Buchungshinweis statt einer stumm deaktivierten Kachel.
          onClick={() =>
            permissions?.isSubstitutionAppEnabled()
              ? navigate(t('routes.substitutionAppSettings.slug'))
              : showLicenseHint({ kind: 'app' })
          }
        />
      </IconMenu>
    </Page>
  );
};
